import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { F, Button, Flex, Field, Divider } from 'nallian-shared-ui/lib/components';
import { SelectFieldValueComponent } from 'nallian-shared-ui/lib/components/redux-form-semantic-ui';
import ReadOnlyfieldValueComponent from '../../../app/components/ReadOnlyFieldValueComponent';

const FieldFlex = styled(Flex)`
  && .field {
    width: 100%;
    margin: 0;
  }
`;

const FieldLabel = styled.label`
  margin: 0 0 0.28571429rem 0;
  color: rgba(0, 0, 0, 0.87);
  font-size: 0.92857143em;
  font-weight: bold;
`;

const OwnerFields = ({ communities, organisations, fields, submitProcessing, readOnly }) => {
  const { t } = useTranslation();

  const handleAddFieldClick = useCallback(() => fields.push({}), [fields]);
  const handleRemoveFieldClick = useCallback((_, { i }) => fields.remove(i), [fields]);

  return (
    <F.Field error={false}>
      <Flex fluid direction="column" margin="-1rem 0 0 0">
        <FieldLabel htmlFor="-">{t('owners')}</FieldLabel>
        <Divider />
        <FieldFlex fluid direction="column" alignItems="flex-start">
          {fields.map((f, index) => (
            <Flex key={`owner_${index}`} fluid alignItems="center">
              <Field
                fluid
                search
                clearable
                label={index === 0 && t('community')}
                name={`${f}.communityId`}
                options={communities}
                valueComponent={readOnly ? ReadOnlyfieldValueComponent : SelectFieldValueComponent}
                disabled={submitProcessing}
              />
              <Flex margin="0 0.5rem" />
              <Field
                fluid
                search
                clearable
                label={index === 0 && t('organisation')}
                name={`${f}.organisationId`}
                options={organisations}
                valueComponent={readOnly ? ReadOnlyfieldValueComponent : SelectFieldValueComponent}
                disabled={submitProcessing}
              />
              <Flex margin="0 0.5rem" />
              {!readOnly && (
                <Flex
                  direction="column"
                  alignItems="flex-start"
                  margin={index === 0 ? '1.5rem 0.75rem 0' : '0 0.75rem 0'}
                >
                  <Button
                    iconbutton
                    linkbutton
                    icon="close"
                    type="button"
                    tabindex="-1"
                    i={index}
                    onClick={handleRemoveFieldClick}
                  />
                </Flex>
              )}
            </Flex>
          ))}
          {!readOnly && (
            <Flex fluid justifyContent="flex-start" margin="1rem 0 0 0">
              <Button
                linkbutton
                icon="add"
                type="button"
                tabindex="-1"
                content={t('addOwner')}
                onClick={handleAddFieldClick}
              />
            </Flex>
          )}
        </FieldFlex>
      </Flex>
    </F.Field>
  );
};

OwnerFields.propTypes = {
  readOnly: PropTypes.bool.isRequired,
  fields: PropTypes.array.isRequired,
  submitProcessing: PropTypes.bool.isRequired,
  organisations: PropTypes.array,
  communities: PropTypes.array,
};

OwnerFields.defaultProps = { communities: [], organisations: [] };

export default OwnerFields;
